import React from 'react';
import { Instagram, MessageCircle, Facebook, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { socialMedia, professorData } from '../mock';
import Header from '../components/Header';
import Footer from '../components/Footer';

export const ContatoPage = () => {
  const contactOptions = [
    {
      name: 'Instagram',
      icon: Instagram,
      url: socialMedia.instagram,
      color: 'bg-gradient-to-br from-purple-500 to-pink-500',
      description: 'Siga no Instagram'
    },
    {
      name: 'WhatsApp',
      icon: MessageCircle,
      url: socialMedia.whatsapp,
      color: 'bg-green-500',
      description: 'Converse pelo WhatsApp'
    },
    {
      name: 'Facebook',
      icon: Facebook,
      url: socialMedia.facebook,
      color: 'bg-blue-600',
      description: 'Curta a página no Facebook'
    },
    {
      name: 'E-mail',
      icon: Mail,
      url: `mailto:${socialMedia.email}`,
      color: 'bg-gray-700',
      description: 'Envie um e-mail'
    }
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#0F172A] to-[#1e293b] text-white py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4">
              Contato
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              Entre em contato com {professorData.name} através das redes sociais
            </p>
          </div>
        </section>

        {/* Contact Options */}
        <section className="py-16 md:py-20">
          <div className="max-w-5xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-8">
              {contactOptions.map((option) => {
                const IconComponent = option.icon;
                return (
                  <Card key={option.name} className="overflow-hidden hover:shadow-xl transition-all duration-300 border-0 hover:scale-105">
                    <CardContent className="p-8 bg-white">
                      <div className="flex flex-col items-center text-center space-y-4">
                        <div className={`w-20 h-20 ${option.color} rounded-full flex items-center justify-center`}>
                          <IconComponent size={40} className="text-white" />
                        </div>
                        <h3 className="text-2xl font-serif font-semibold text-[#0F172A]">
                          {option.name}
                        </h3>
                        <p className="text-gray-600">
                          {option.description}
                        </p>
                        <Button 
                          onClick={() => window.open(option.url, '_blank')}
                          className="bg-[#0F172A] hover:bg-[#1e293b] text-white px-6 py-3 rounded-lg transition-colors duration-300"
                        >
                          Acessar {option.name}
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default ContatoPage;